<template>
  <b-form-select
    class="grey-input"
    :disabled="isComboSelected"
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    :options="optionStores"
  >
    <template #first>
      <b-form-select-option :value="0" 
        >Todos</b-form-select-option
      >
    </template>
  </b-form-select>
</template>
<script>
//import axios from "axios";
import { mapState } from "vuex";
import {getStores} from '../assets/js/common'
export default {
  name: "ComboStore",
  props: ["value", "isComboSelected"],
  data() {
    return {
      optionStores: [],
    };
  },
  computed:{
    ...mapState("module", [
      "token"
    ]),
  },
  created() {
    this.getStoresCombo();
  },
  methods: {
    async getStoresCombo() {
      try {
        let data = await getStores();
        this.optionStores = data;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style scoped>
.custom-select:disabled {
  background: white !important;
  border-bottom: none !important;
}
.custom-select:disabled {
  color: #000000 !important;
}
</style>